import { Popover as AntPopover } from 'antd';
import { ComponentPropsWithRef } from 'react';
import * as React from 'react';
import styled from 'styled-components';

type Props = Omit<
  ComponentPropsWithRef<typeof AntPopover>,
  'title' | 'overlay' | 'overlayClassName'
> & {
  isDisabled?: boolean;
};

const PopoverComponent = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props>
>((props, ref) => {
  const { className, key, ...rest } = props;

  return <AntPopover overlayClassName={className} ref={ref} {...rest} />;
});

PopoverComponent.displayName = 'PopoverComponent';

export const Popover = styled(PopoverComponent)<Props>`
  &,
  .ant-popover-inner-content {
    padding: 0;
  }
  .ant-popover-inner {
    border-radius: var(--border-radius-small);
    overflow: hidden;
    box-shadow: var(--shadow-32);
  }

  .ant-popover-arrow {
    display: none;
  }

  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
`;
